import { createSlice } from '@reduxjs/toolkit';

import { notify } from 'utils';

import { LAYERS_REDUCER_NAMES } from '../constants';

import { getMapEntitiesHistogramThunk } from './actions';
import {
  initialImageryTimelineState,
  initialTimelineTypesState,
} from './constants';
import {
  SetFiltersAction,
  SetImageryTimelineStateAction,
  SetIsMapDataLoadedAction,
  SetIsTimelineAction,
  SetMapDndState,
  SetSharedEntityIdAction,
  SetStateAction,
  SetTemporaryEntitiesAction,
  StateState,
} from './types';

export const initialState: StateState = {
  filters: {},
  temporaryEntities: [],
  sharedEntityId: '',
  isMapDataLoaded: false,
  mapDndState: {
    hasTabSwitched: false,
    droppableParentNodeId: null,
  },
  histogram: {},
  timelineTypes: initialTimelineTypesState,
  imageryTimelineState: initialImageryTimelineState,
};

const stateSlice = createSlice({
  name: LAYERS_REDUCER_NAMES.STATE,
  initialState: initialState,
  reducers: {
    setState(state, action: SetStateAction) {
      return action.payload;
    },
    setFilters(state, action: SetFiltersAction) {
      state.filters = action.payload;
    },
    setTemporaryEntities(state, action: SetTemporaryEntitiesAction) {
      state.temporaryEntities = action.payload;
    },
    setSharedEntityId(state, action: SetSharedEntityIdAction) {
      state.sharedEntityId = action.payload;
    },
    setIsMapDataLoaded(state, action: SetIsMapDataLoadedAction) {
      state.isMapDataLoaded = action.payload;
    },
    setMapDndState(state, action: SetMapDndState) {
      const { key, value } = action.payload;
      state.mapDndState = { ...state.mapDndState, [key]: value };
    },
    setTimelineTypes(state, action: SetIsTimelineAction) {
      state.timelineTypes = action.payload;
    },
    setImageryTimelineState(state, action: SetImageryTimelineStateAction) {
      state.imageryTimelineState = action.payload;
    },
    resetImageryTimelineState(state) {
      state.imageryTimelineState = initialImageryTimelineState;
    },
    resetState() {
      return initialState;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getMapEntitiesHistogramThunk.fulfilled, (state, action) => {
        state.histogram = action.payload.histogram;
      })
      .addCase(getMapEntitiesHistogramThunk.rejected, (state, action) => {
        notify.error(action.payload?.message);
      }),
});

export const { actions: stateActions, reducer: stateReducer } = stateSlice;
